import { logger } from '../../../utils/logger';
import { ApiErrorHandler } from '../error.handler';
import axios from 'axios';

class StripeEndpoints {
  private static instance: StripeEndpoints;

  static getInstance(): StripeEndpoints {
    if (!StripeEndpoints.instance) {
      StripeEndpoints.instance = new StripeEndpoints();
    }
    return StripeEndpoints.instance;
  }

  // Asynchronous function to fetch dashboard data for a given organization
  async getPlans(): Promise<any> {
    try {
      // Make a GET request to the API to fetch dashboard data
      const response = await axios.get(
        `${import.meta.env.VITE_PUBLIC_API_BASE_URL}/organisation/plans`
      );

      // Return the data from the response
      return response.data;
    } catch (error) {
      // Log an error if the request fails
      logger.error('Failed to fetch Dashboard Datas:', error);
      // Handle the error and return the error message
      return ApiErrorHandler.handle(error);
    }
  }
}

export const stripeEndpoints = StripeEndpoints.getInstance();
